import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "layout/atoms/Button";
import Icon from "layout/atoms/Icon";

import { ReactComponent as EyeSvg } from "assets/icons/eye.svg";
import { ReactComponent as HeartFillSvg } from "assets/icons/heart-fill.svg";
import { ReactComponent as HeartSvg } from "assets/icons/heart.svg";
import { HeartIconWrapper, Wrapper } from "./styles";

const VotesCounter = ({
  small,
  votesNumber,
  isVotedByMe,
  onVoteClick,
  onVotersLookupClick,
  lookupVoters = false,
  viewMode = "normal",
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "boardsDetails.ideaCard",
  });
  const [animateVote, setAnimateVote] = useState(false);

  const handleVoteClick = () => {
    if (!isVotedByMe) {
      setAnimateVote(true);
      setTimeout(() => setAnimateVote(false), 400);
    }
    onVoteClick && onVoteClick();
  };

  const handleVotersLookupClick = () => {
    onVotersLookupClick && onVotersLookupClick();
  };

  const lookupVotersVisible = lookupVoters && votesNumber > 0;

  return small ? (
    <Button size="sm" color="white" onClick={handleVoteClick}>
      <HeartIconWrapper isVotedByMe={isVotedByMe}>
        <Icon src={HeartSvg} />
        <Icon src={HeartFillSvg} size="18px" />
      </HeartIconWrapper>
      <p>{votesNumber}</p>
    </Button>
  ) : (
    <Wrapper isVotedByMe={isVotedByMe} $viewMode={viewMode}>
      <div onClick={handleVoteClick}>
        <strong>{votesNumber}</strong>
      </div>
      {viewMode === "normal" && (
        <>
          <Button size="sm" color="white" onClick={handleVoteClick}>
            <HeartIconWrapper
              isVotedByMe={isVotedByMe}
              animateVote={animateVote}
            >
              <Icon src={HeartSvg} />
              <Icon src={HeartFillSvg} size="18px" />
            </HeartIconWrapper>
            <p>{isVotedByMe ? t("unvote") : t("vote")}</p>
          </Button>
          {lookupVotersVisible && (
            <Button size="sm" color="white" onClick={handleVotersLookupClick}>
              <Icon src={EyeSvg} />
              <p>{t("lookupVoters")}</p>
            </Button>
          )}
        </>
      )}
    </Wrapper>
  );
};

VotesCounter.propTypes = {
  votesNumber: PropTypes.number,
  isVotedByMe: PropTypes.bool,
  onVoteClick: PropTypes.func,
};

export default VotesCounter;
